<template>
  <v-overlay v-if="dialog" :opacity="1">
    <v-dialog v-model="dialog" width="95%" persistent>
      <fullscreen v-model="fullscreen">
        <v-card color="black">
          <div>
            <v-card-title>
              <div class="tw-flex tw-justify-between tw-w-full tw-items-center">
                <strong> {{ game && game.name }} (Lobby)</strong>
                <div class="tw-space-x-2">
                  <v-btn fab small v-if="!fullscreen" @click="fullscreen = true">
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-btn>
                  <v-btn fab small v-else @click="fullscreen = false">
                    <v-icon>mdi-fullscreen-exit</v-icon>
                  </v-btn>
                  <v-btn fab small @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card-title>

            <v-divider> </v-divider>
            <div :class="`grid-lobbies tw-p-4 tw-overflow-y-auto ${fullscreen ? 'fullscreen' : 'tw-h-[810px]'}`">
              <div @click="gotoGame(lobby)" v-for="(lobby,i) in lobbies" :key="i" class="tw-relative tw-h-[160px]">
                <LobbyData :lobby="lobby" />
              </div>
            </div>
            <v-card-actions>

            </v-card-actions>
          </div>
        </v-card>
      </fullscreen>
    </v-dialog>
  </v-overlay>
</template>

<script>
import { mapActions } from "vuex";
import LobbyData from "../LobbyData.vue";
export default {
  props: ["show", "game"],
  components: {
    LobbyData,
  },
  data: () => ({
    dialog: false,
    fullscreen: false,
    lobbies: [],
  }),
  async mounted() {
    this.dialog = this.show;
    await this.getGameLobby();
  },
  watch: {
    show() {
      this.dialog = this.show;
    },
  },
  methods: {
    ...mapActions("game", ["getLobby"]),
    async getGameLobby() {
      const lobby = await this.getLobby({
        game_uuid: this.game.uuid,
        // currency: "EUR",
      });
      this.lobbies = lobby;
    },
    gotoGame(lobby) {
      this.$router.push({
        path: "/live-games/real/play",
        query: {
          id: this.game.id,
          d: lobby.lobbyData,
        },
      });
    },
  },
};
</script>

<style scoped>
.v-dialog__content {
  align-items: center;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.fullscreen {
  height: calc(100vh - 100px);
}
</style>